import type { KindMap, UnitValues } from './formKinds.types';

/** Client-only ids for not-yet-persisted rows; never reach a payload. */
export type LocalId = `local-${string}`;

export type RowId =
  | { type: 'persisted'; id: number }
  | { type: 'local'; localId: LocalId };

/** One row of a list unit: its id and its fields' values. */
export type ListItemValues<M extends KindMap<M>> = {
  rowId: RowId;
  values: UnitValues<M>;
};

let localIdCounter = 0;
export function createLocalId(): LocalId {
  localIdCounter += 1;
  return `local-${Date.now().toString(36)}-${localIdCounter}`;
}

export const rowIdUtils = {
  persisted(id: number): RowId {
    return { type: 'persisted', id };
  },
  local(): RowId {
    return { type: 'local', localId: createLocalId() };
  },
  key(rowId: RowId): string {
    return rowId.type === 'persisted' ? `p:${rowId.id}` : rowId.localId;
  },
  persistedId(rowId: RowId): number | null {
    return rowId.type === 'persisted' ? rowId.id : null;
  },
  equals(a: RowId, b: RowId): boolean {
    return rowIdUtils.key(a) === rowIdUtils.key(b);
  }
};
